angular
.module('avant.interceptors')
.factory 'ServerErrorInterceptor', ['$q', '$window', '$injector', ($q, $window, $injector) ->
  responseError: (response) ->
    return $q.reject(response) unless response.status >= 500
    switch response.status
      when 503
        $window.location.replace '/apply'
      else
        reasons = response.data?.reasons
        if reasons && 'scheduled_maintenance' in reasons
          $injector.get('$state').go 'scheduled_maintenance'
        else
          $injector.get('$state').go('service_failure', reasons: reasons)
    $q.reject response
]
